module.exports = __webpack_public_path__ + "fonts/Montserrat-SemiBold.d5e0cc7.ttf";